import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { Tabs } from 'components/FbUI/Tabs'
import { NotificationPreferencesTable } from 'features/settings/components/NotificationPreferencesTable'
import { useAuth } from 'context/authentication/useAuth'

const DEFAULT_TAB = 'platform'

const ALL_TABS = [
  { key: 'platform', title: 'Platform' },
  { key: 'deals', title: 'Deals' },
  { key: 'contacts', title: 'Contacts' },
  { key: 'campaigns', title: 'Campaigns' },
  { key: 'rebates', title: 'Rebates' },
]

// Limited (broker) users only have access to product-related notifications;
// the backend filters the preference rows accordingly (see
// server/notifications/constants.py LIMITED_USER_VISIBLE_NOTIFICATION_SLUGS).
const LIMITED_USER_TABS = ALL_TABS.filter((t) => t.key === 'platform')

export function NotificationsSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const { isLimited } = useAuth()
  const tab = params.tab ?? DEFAULT_TAB

  const tabs = isLimited ? LIMITED_USER_TABS : ALL_TABS
  const validTabs = new Set(tabs.map((t) => t.key))

  if (params.tab && !validTabs.has(params.tab)) {
    return <Navigate to={`/settings/notifications/${DEFAULT_TAB}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={tab}
          setSelectedTab={(value) =>
            navigate(`/settings/notifications/${value}`)
          }
          tabStyle={{ width: '125px' }}
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer>
        <NotificationPreferencesTable tab={tab} />
      </FBPageTableContainer>
    </div>
  )
}
